<template>
  <footer class="footer-background">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-column" style="display: flex; flex-direction: column;">
          <p class="website-name">JobBoardy</p>
          <p class="footer-text">
            Post your job everywhere in 2 minutes with JobBoardy
          </p>
          <button
            @click="$router.push({ path: '/post-job' })"
            class="primary-button small-button"
            style="font-size: 0.8rem; margin-bottom: 0.3rem;"
            type="button"
          >
            Post job
          </button>
          <button
            @click="$router.push({ path: '/suggest-site' })"
            class="tertiary-button small-button"
            style="font-size: 0.8rem;"
            type="button"
          >
            Suggest site
          </button>
        </div>

        <div class="footer-column">
          <p class="footer-text">PRODUCT</p>
          <p @click="$router.push({ path: '/blog' })" style="cursor: pointer;" class="footer-text">
            Blog
          </p>
          <p @click="$router.push({ path: '/features' })" style="cursor: pointer;" class="footer-text">
            Features
          </p>
          <p @click="$router.push({ path: '/pricing' })" style="cursor: pointer;" class="footer-text">
            Pricing
          </p>
          <p @click="$router.push({ path: '/help' })" style="cursor: pointer;" class="footer-text">
            Help
          </p>
        </div>

        <div class="footer-column">
          <p class="footer-text">COMPANY</p>
          <p @click="$router.push({ path: '/privacy' })" style="cursor: pointer;" class="footer-text">
            Privacy Policy & Terms and Conditions
          </p>
          <p @click="$router.push({ path: '/our-jobs/' })" style="cursor: pointer;" class="footer-text">
            Work with us
          </p>
        </div>

        <div class="footer-column">
          <p class="footer-text">CONTACT</p>
          <p class="footer-text">hello@monthlystart.com</p>
        </div>
      </div>

      <div class="center-items" style="margin:0rem;">
        <a href="https://www.linkedin.com/company/jobboardy/" rel="external nofollow noopener" target="_blank"
          ><i class="fab fa-linkedin icon-social-media"></i
        ></a>
        <a href="https://twitter.com/jobboardy" rel="external nofollow noopener" target="_blank"
          ><i class="fab fa-twitter icon-social-media"></i
        ></a>
        <a href="https://www.facebook.com/JobBoardy-101458221867028/" rel="external nofollow noopener" target="_blank"
          ><i class="fab fa-facebook-square icon-social-media"></i
        ></a>
        <a href="https://www.instagram.com/jobboardy/" rel="external nofollow noopener" target="_blank"
          ><i class="fab fa-instagram icon-social-media"></i
        ></a>
      </div>

      <p class="footer-text" style="text-align: center;">
        Copyright © 2021 JobBoardy. All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped></style>
